import CryptoJS from 'crypto-js';

// const getAesKeyWordArray = () => {
//   const base64Key = privacyConfig?.secret;
//   if (base64Key) {
//     const parsed = CryptoJS.enc.Base64.parse(base64Key);
//     // AES-128 requires a 16-byte key. If a longer key is configured, use the first 16 bytes.
//     return CryptoJS.lib.WordArray.create(parsed.words.slice(0, 4), 16);
//   }

//   return null;
// };

// export const decryptAES = (cipherText) => {
//   try {
//     if (!cipherText) return false;

//     const encryptedText = cipherText.replace(' ', '+');
//     const key = getAesKeyWordArray();
//     if (!key) return false;

//     const iv = CryptoJS.enc.Base64.parse(privacyConfig?.aesIv);

//     const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
//       iv,
//       mode: CryptoJS.mode.CBC,
//       padding: CryptoJS.pad.Pkcs7,
//     });

//     const result = decrypted.toString(CryptoJS.enc.Utf8);
//     return result || false;
//   } catch (err) {
//     console.error('AES Decryption failed:', err);
//     return false;
//   }
// };

// export const encryptAES = (email) => {
//   try {
//     if (!email) return false;

//     const key = getAesKeyWordArray();
//     if (!key) return false;

//     const iv = CryptoJS.enc.Base64.parse(privacyConfig?.aesIv);

//     const encrypted = CryptoJS.AES.encrypt(email, key, {
//       iv,
//       mode: CryptoJS.mode.CBC,
//       padding: CryptoJS.pad.Pkcs7,
//     });

//     return encrypted.toString();
//   } catch (err) {
//     return false;
//   }
// };

export const decrypt3DES = (cipherHex, encryptionKeys) => {
  try {
    const {
      encryptionKey,
      desIv
    } = encryptionKeys;
    const cipherWA = CryptoJS.enc.Hex.parse(cipherHex);
    const key = CryptoJS.enc.Hex.parse(encryptionKey);
    const iv = CryptoJS.enc.Hex.parse(desIv);
    const decrypted = CryptoJS.TripleDES.decrypt({
      ciphertext: cipherWA
    }, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.NoPadding
    });
    let result = decrypted.toString(CryptoJS.enc.Utf8);

    // console.log('Raw decrypted:', result);

    // 🔹 replicate backend logic
    if (result) {
      result = result.replace(/\0/g, ''); // remove null chars
      result = result.slice(4);
      const endIndex = result.indexOf('OCC');
      if (endIndex !== -1) {
        result = result.slice(0, endIndex);
      }
    }

    // console.log('Final email:', result);

    return result;
  } catch (err) {
    console.error('Decryption failed:', err);
    return null;
  }
};

// export const encrypt3DES = (email) => {
//   const { SECRET_KEY } = privacyConfig;

//   const key = CryptoJS.enc.Hex.parse(SECRET_KEY);
//   const iv = CryptoJS.enc.Hex.parse(privacyConfig?.desIv);

//   // 🔹 match backend format
//   let formatted = `xxxx${email}OCC`;

//   // 🔹 manual padding (important)
//   while (formatted.length % 8 !== 0) {
//     formatted += '\0';
//   }

//   const encrypted = CryptoJS.TripleDES.encrypt(
//     CryptoJS.enc.Utf8.parse(formatted),
//     key,
//     {
//       iv,
//       mode: CryptoJS.mode.CBC,
//       padding: CryptoJS.pad.NoPadding,
//     },
//   );

//   return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
// };